<template>
    <div id="contextMenu" v-if="showContextMenu && this.$store.getters.isShowPopUps" v-bind:style="'position:absolute; top:' + this.y + 'px;left:' + this.x + 'px;'">
        <div class="menu">
            <ul>
                <template v-for="(link, index) in menuLinks">
                    <li :key="index" style="width:100%;box-sizing: border-box;" @click="link.click" ><span>{{link.title}}</span></li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "PSContextMenu",
    props: {
        menuLinks: {
            type: Array, 
            required: true,
            default: []
        }
    },
    data() {
    	return {
            showContextMenu: false,
            x: 0,
            y: 0
    	}
    },
    computed: {
    
    },
    created() {
    
    },
    mounted() {
        window.Bus.$on("ContextMenuClose", d => {
            this.showContextMenu = false;
        });
        window.Bus.$on("ContextMenuOpen", (e) => {
            e.preventDefault();
            this.x = e.clientX;
            this.y = e.clientY;
            //adjust for overflow of iframe window
            if (e.clientX + 200 > $(window).width()){
                this.x = e.clientX - 200;
            }

            if (e.clientY + $('#contextMenu').height() > $(window).height()){
                this.y = e.clientY - $('#contextMenu').height();
            }
            this.showContextMenu = true;
        });

        window.Bus.$on("DefaultWidgetDelete", () => {
            var obj = {
                'name': 'deleteWidget',
                'widgetID' : 1
            };
            window.parent.postMessage(JSON.stringify(obj), "*");
        });
    },
    methods: {
    }    
    
}
</script>
<style lang="scss">
@import "../styles/ps-context-menu.scss";
</style>